$(document).ready(() => {
  const handler = location.pathname.split("/")[location.pathname.split("/").length - 1];
  let localPrice = window.productPrice / 100;

  $(document.body).on("prices", (_, priceList) => {
    const $input = $(".product__info-container--sticky input[name=quantity]");
    if (priceList.length > 0) {
      localPrice = getLocalPrice(priceList, $input.val());
    }

    if ($("#pp-price").length > 0) {
      $("#pp-price")[0].dataset.ppAmount = localPrice * $input.val()
    }

    $input.on("change", (e) => {
      const quantity = $input.val();
      if (priceList.length > 0) {
        localPrice = getLocalPrice(priceList, quantity)
      }

      if ($("#pp-price").length > 0) {
        $("#pp-price")[0].dataset.ppAmount = localPrice * $input.val()
      }
    });
  })
});

function getLocalPrice(list, quantity) {
  for (elem of list) {
    if (elem.quantity <= quantity) {
      return elem.price.replace(/[^0-9,.]/g, "");
    }
  }

  return null
}